
const iikoBiz = ({ iikoUserId, setIikoUserId, iikoSecret, setIikoSecret, iikoOrgId, setIikoOrgId }) => {

    return (
        <>
            <div className="col-span-1 col-start-1">
                <label htmlFor="iikoUserId" className="block text-sm font-medium text-gray-700">iiko User ID</label>
                <input type="text"
                       id="iikoUserId"
                       value={iikoUserId}
                       onChange={(e) => setIikoUserId(e.target.value)}
                       className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
            </div>
            <div className="col-span-1 col-start-1">
                <label htmlFor="iikoSecret" className="block text-sm font-medium text-gray-700">iiko User Secret</label>
                <input type="text"
                       id="iikoSecret"
                       value={iikoSecret}
                       onChange={ (e) => setIikoSecret(e.target.value)}
                       className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
            </div>
            <div className="col-span-1 col-start-1">
                <label htmlFor="iikoOrgId" className="block text-sm font-medium text-gray-700">iiko Organization ID</label>
                <input type="text"
                       id="iikoOrgId"
                       value={iikoOrgId}
                       onChange={ (e) => setIikoOrgId(e.target.value)}
                       className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
            </div>
        </>
    )
}
export default iikoBiz;
